import { Component } from "react";
import "./Checkbox.css";
import PropTypes from "prop-types";

export default class Checkbox extends Component {
  render() {
    return (
      <label className="talaera-checkbox checkcontainer">
        <input
          type="checkbox"
          checked={this.props.isChecked}
          onChange={this.props.onChange}
          disabled={this.props.isDisabled}
        />
        <span className={"checkmark" + (this.props.isDisabled ? " disabled" : "")}></span>
        <label>{this.props.label}</label>
        {this.props.note && <span className="checkbox-note">{this.props.note}</span>}
      </label>
    );
  }
}

Checkbox.propTypes = {
  /** This checkbox's value: checked or not checked.*/
  isChecked: PropTypes.bool,
  /** A label of the checkbox element.*/
  label: PropTypes.string,
  /** Specifies if the checkbox is disabled. */
  isDisabled: PropTypes.bool,
  /** A checkbox's note. */
  note: PropTypes.string,
  /** 'Check' handler.*/
  onChange: PropTypes.func,
};
